import { SegmentInterface } from 'services/analytics/segment/types';

export const logErrorEvent = ({
  segmentClient,
  source_name,
  error_message,
  screen,
}: {
  segmentClient: SegmentInterface;
  source_name: string;
  error_message: string;
  screen?: string;
}) => {
  void segmentClient.logEvent('Bill Switch Error Encountered', {
    source_name,
    error_message,
    screen: screen ?? 'product_intro',
    category: 'bill_switch',
  });
};
